"use strict";
/*
 * Copyright 2020 - MATTR Limited
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *     http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertBase64urlToBase58 = void 0;
const rfc4648_1 = require("rfc4648");
const bs58_1 = __importDefault(require("bs58"));
const convertBase64urlToBase58 = (value) => {
    return bs58_1.default.encode(rfc4648_1.base64url.parse(value, { loose: true }));
};
exports.convertBase64urlToBase58 = convertBase64urlToBase58;
//# sourceMappingURL=codec.js.map